export const CURRENT_AGREEMENT_VERSION = '2026-04-06'

// MRG-281 — Legal-approved external-agent ToS, rendered from
// docs/legal/external-agent-tos.md. Bumping forces re-acceptance for all
// active external agents on next login. Must match the API constant
// CURRENT_EXTERNAL_AGENT_TERMS_VERSION in api/cash_offer_api/constants/agreement.py.
export const CURRENT_EXTERNAL_AGENT_TERMS_VERSION = 'external-agent-2026-05-01'
